export default __webpack_public_path__ + "static/media/lock-icon.ce3ad0cc.svg";